import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { GroupContextMoreInfoBlobInput } from 'components/common/group/GroupContextMoreInfoBlob';
import { buildGroupContactInfoMap } from 'global/services-helpers/groupService';
import { makeAutoObservable } from 'mobx';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';
import GroupModule from 'store/modules/group/groupModule';

export class EnrollmentGroupInfoDelegate {
  private _groupModule: GroupModule;
  private _enrollmentPeriodModule: EnrollmentPeriodModule;

  public get moreInfoBlobInput(): GroupContextMoreInfoBlobInput | null {
    if (this.isFlowDataLoading) return null;
    const group = this._groupModule.group;
    const effectiveDate = this._enrollmentPeriodModule.enrollmentPeriod?.effectiveDate || '';

    return {
      blobTitle: group.name,
      generalInfoMap: {
        group: group.name,
        'effective date': effectiveDate ? dateFormatters.normDateToShortAmericanDate(effectiveDate) : '',
      },
      contactInfoMap: buildGroupContactInfoMap(group.contactInfo),
    };
  }

  public get isFlowDataLoading(): boolean {
    return this._groupModule.isLoading || this._enrollmentPeriodModule.isLoading;
  }

  constructor(groupModule: GroupModule, enrollmentPeriodModule: EnrollmentPeriodModule) {
    this._groupModule = groupModule;
    this._enrollmentPeriodModule = enrollmentPeriodModule;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
